export enum E_EstadoLIO {
    EnConstruccion = 1,
    RevisarCierreAcciones = 2,
    Cerrado = 3,//algunos registros antiguos vienen con id 3
    RevisionContratista = 4,
    ValidacionEncargado = 5,
    Cerrado2 = 6,
    CerradoConObservacion = 7,
    AccionesEnEjecucion = 8
  }

export enum E_EstadoLIOAspectoEvaluar {
  EnConstruccion = 1,
  NoAplica = 2,
  Asignado = 3,
  AsignadoExternoContratista = 4,
  AccionRealizada = 5,
  Cerrado = 6,
  CerradoConObservacion = 7,
  AsignadoContratista = 8,
  Rechazado = 9
}